var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$slots.title)?_c('div',{staticClass:"sec-title font-en"},[_vm._t("title"),_vm._v(" "),_c('br',{staticClass:"sp-visible"}),_vm._v(" "),(_vm.$slots.sub)?_c('span',[_vm._t("sub")],2):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('div',{staticClass:"sec-description"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }